import { useEffect, useState } from 'react';
import { ArrowLeft, CheckCircle2, Clock, XCircle } from 'lucide-react';
import { BrandLogo } from './BrandLogo';
import { LegalFooter } from './LegalFooter';
import { formatApiPrice, getOrderStatus, type OrderStatusPayload } from '../lib/commerceApi';

type OrderThanksPageProps = {
  orderNumber: string;
};

function statusCopy(status?: string) {
  if (status === 'paid') return { icon: <CheckCircle2 />, title: 'Betaling ontvangen.', text: 'We verwerken je bestelling volgens de bevestigde ordergegevens.' };
  if (status === 'payment_failed' || status === 'canceled' || status === 'expired') return { icon: <XCircle />, title: 'Betaling niet afgerond.', text: 'Er is geen succesvolle betaling geregistreerd.' };
  return { icon: <Clock />, title: 'Betaling wordt gecontroleerd.', text: 'Mollie stuurt de definitieve status via de webhook. Ververs later opnieuw als de status nog openstaat.' };
}

export function OrderThanksPage({ orderNumber }: OrderThanksPageProps) {
  const [order, setOrder] = useState<OrderStatusPayload | null>(null);
  const [message, setMessage] = useState('Orderstatus laden...');

  useEffect(() => {
    document.title = `Bestelling ${orderNumber} | ProPickleball.nl`;
    getOrderStatus(orderNumber)
      .then((payload) => {
        setOrder(payload);
        setMessage('Orderstatus opgehaald.');
      })
      .catch(() => setMessage('De orderstatus kon nog niet worden opgehaald.'));
  }, [orderNumber]);

  const copy = statusCopy(order?.status);

  return (
    <>
      <main className="checkoutPage">
        <nav className="productTopbar" aria-label="Bestelling navigatie">
          <BrandLogo compact />
          <a className="backHome" href="/producten/"><ArrowLeft size={18} /> Verder winkelen</a>
        </nav>
        <section className="orderStatusPanel">
          <div className="orderStatusIcon">{copy.icon}</div>
          <p className="eyebrow">Bestelling {orderNumber}</p>
          <h1>{copy.title}</h1>
          <p>{copy.text}</p>
          <dl>
            <div><dt>Status</dt><dd>{order?.status ?? 'onbekend'}</dd></div>
            <div><dt>Bedrag</dt><dd>{order ? formatApiPrice(order.amount_cents) : 'Nog niet beschikbaar'}</dd></div>
            <div><dt>Laatste update</dt><dd>{order?.updated_at ? new Date(order.updated_at).toLocaleString('nl-NL') : message}</dd></div>
          </dl>
          <a className="secondaryDarkCta" href="/contact/">Contact opnemen</a>
        </section>
      </main>
      <LegalFooter />
    </>
  );
}
